<!-- CC: extracted from threat-prevention-rules.component.html -> Configure Notification Options popup -->

<!-- CC: popup mode (default) -->
<popup-c *ngIf="notifyOptionsPopup?.show && !isEmbedded"
         class="show-in-o-wizard"
		 head="Configure Notification Options"
		 subTitle="Changes will apply to all Threat Prevention rules types"
		 (closeCb)="closeCb.emit()"
		 (confirmCb)="changeNotifyPeriod()"
		 [buttons]="{confirm: {text: 'Confirm', loading: notifyOptionsPopup.changeNotifyPeriodInProcess}}"
		 size="large">
	<ng-container *ngTemplateOutlet="notifyOptionsContent"></ng-container>
</popup-c>

<!-- CC: embedded mode (wizard) — save is triggered externally via changeNotifyPeriod() -->
<div class="flxClmn vSpace1 f-1-0" *ngIf="notifyOptionsPopup?.show && isEmbedded">
	<ng-container *ngTemplateOutlet="notifyOptionsContent"></ng-container>
</div>

<ng-template #notifyOptionsContent>
	<div class="flxClmn vSpace1 f-1-0">

		<div class="simple-tab-row w100 flxRow">
			<ng-container *ngFor="let tab of notifyOptionsPopup.tabs | keyvalue: gs.returnZero">
				<div class="tab-header"
				     [ngClass]="{'chosen' : notifyOptionsPopup.activeTab === tab.value}"
				     (click)="notifyOptionsPopup.activeTab = tab.value">
					<span class="hvr-opacity">{{tab.value}}</span>
				</div>
			</ng-container>
		</div>

		<div class="list-group list-group-flush settings-list-container" *ngIf="notifyOptionsPopup.activeTab === notifyOptionsPopup.tabs.reviewer">

			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Notification Timing</b>
					<span class="lh-base" style="font-size: 0.9em;">Configure the timing and frequency of Inbound Shield notifications</span>
				</div>
				<div class="content-container pt-1">
					<app-dropdown-c style="width: 100%; max-width: 420px;"
					                [error]="notifyOptionsPopup.isNotifyReviewerPeriodsError"
					                text="{{notifyOptionsPopup.notifyReviewerPeriods && _.keys(_.pickBy(notifyOptionsPopup.notifyReviewerPeriods)).join(', ').replace('Notify every day', 'Custom notification times') || 'Select'}}">
						<li *ngFor="let periodKey of dic.CONSTANTS.tpRule.notifyOptions | keyvalue: gs.returnZero"
						    (click)="notifyOptionsPopup.notifyReviewerPeriods[periodKey.value] = !notifyOptionsPopup.notifyReviewerPeriods[periodKey.value]; notifyOptionsPopup.isNotifyReviewerPeriodsError = false; $event.stopPropagation();"
						    id="{{'notifyReviewerPeriod_' + periodKey.key}}">
							<checkbox (click)="$event.preventDefault();"
							          [(model)]="notifyOptionsPopup.notifyReviewerPeriods[periodKey.value]">
								{{periodKey.value === dic.CONSTANTS.tpRule.notifyOptions.everyDay ? 'Custom notification times' : periodKey.value}}
							</checkbox>
						</li>
					</app-dropdown-c>
					<span style="position: absolute; bottom: -20px; right: 0;  font-size: 12px; color: red;"
					      *ngIf="notifyOptionsPopup.isNotifyReviewerPeriodsError">
                            required field
					</span>
				</div>
			</div>

			<div class="list-group-item settings-list-item py-4" *ngIf="notifyOptionsPopup.notifyReviewerPeriods[dic.CONSTANTS.tpRule.notifyOptions.everyDay]">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Notification Hours</b>
					<span class="lh-base" style="font-size: 0.9em;">Select the hours of the day in which Inbound Shield notifications will be sent</span>
				</div>
				<div class="content-container pt-1">
					<app-dropdown-c class="limit-height" style="width: 200px;"
					                [error]="notifyOptionsPopup.isNotifyReviewerDailyHoursError"
					                text="{{gs.getDailyHoursText(notifyOptionsPopup.notifyReviewerDailyHours) || 'Select'}}">
						<li *ngFor="let twoDigitHour of gs.hoursArr"
						    (click)="toggleNotificationDailyHour(notifyOptionsPopup.notifyReviewerDailyHours, twoDigitHour); $event.stopPropagation();"
						    id="{{'notifyReviewerDailyHour_' + twoDigitHour}}">
							<checkbox (click)="$event.preventDefault();"
							          [model]="notifyOptionsPopup.notifyReviewerDailyHours.includes(twoDigitHour)">
								{{twoDigitHour + ':00'}}
							</checkbox>
						</li>
					</app-dropdown-c>
					<span style="position: absolute; bottom: -17px; right: 0;  font-size: 12px; color: red;"
						  *ngIf="notifyOptionsPopup.isNotifyReviewerDailyHoursError">
							required field
					</span>
				</div>
			</div>

			<div class="list-group-item settings-list-item py-4" *ngIf="notifyOptionsPopup.notifyReviewerPeriods[dic.CONSTANTS.tpRule.notifyOptions.everyDay]">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Notification Days</b>
					<span class="lh-base" style="font-size: 0.9em;">Select the days of the week in which Inbound Shield notifications will be sent</span>
				</div>
				<div class="content-container pt-1">
					<app-dropdown-c class="limit-height" style="width: 200px;"
					                [error]="notifyOptionsPopup.isNotifyReviewerDaysError"
					                [items]="notifyOptionsPopup.notifyReviewerDays"
					                [isMultipleSelection]="true"
					                [hideCounter]="true"
					                itemDisplayKey="day">
					</app-dropdown-c>
					<span style="position: absolute; bottom: -17px; right: 0;  font-size: 12px; color: red;"
					      *ngIf="notifyOptionsPopup.isNotifyReviewerDaysError">
                            required field
					</span>
				</div>
			</div>

			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Notification Email Title (Immediate Notification)</b>
					<span class="lh-base" style="font-size: 0.9em;" ngNonBindable>Customize the title of Inbound Shield immediate notifications which are sent to reviewers. The following dynamic fields can also be used - {{RECIPIENT_EMAIL}}, {{EMAIL_SUBJECT}}, {{COMPANY_NAME}}.</span>
				</div>
				<div class="content-container overflow-auto pt-1">
					<input type="text" class="lowerPlaceholder" placeholder="{{quarantineEmailNotificationPlaceholder}}" style="margin: 0; width: 100%; box-sizing: inherit;"
					       [(ngModel)]="notifyOptionsPopup.notifyReviewerEmailTitle"/>
				</div>
			</div>

			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Notification Email Title (Scheduled Notification)</b>
					<span class="lh-base" style="font-size: 0.9em;" ngNonBindable>
Customize the title of Inbound Shield scheduled notifications which are sent to reviewers. The following dynamic fields can also be used - {{COMPANY_NAME}}, {{DETECTED_THREATS}}.
					</span>
				</div>
				<div class="content-container overflow-auto pt-1">
					<input type="text" class="lowerPlaceholder" placeholder="{{quarantineEmailDigestNotificationPlaceholder}}" style="margin: 0; width: 100%; box-sizing: inherit;"
					       [(ngModel)]="notifyOptionsPopup.notifyReviewerEmailDigestTitle"/>
				</div>
			</div>

		</div>

		<div class="list-group list-group-flush settings-list-container" *ngIf="notifyOptionsPopup.activeTab === notifyOptionsPopup.tabs.recipient">
			<span>This setting applies to personal reviewers as well</span>

			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Notification Timing</b>
					<span class="lh-base" style="font-size: 0.9em;">Configure the timing and frequency of Inbound Shield notifications</span>
				</div>
				<div class="content-container pt-1">
					<app-dropdown-c style="width: 100%; max-width: 420px;"
									[error]="notifyOptionsPopup.isNotifyRecipientPeriodsError"
									text="{{notifyOptionsPopup.notifyRecipientPeriods && _.keys(_.pickBy(notifyOptionsPopup.notifyRecipientPeriods)).join(', ').replace('Notify every day', 'Custom notification times') || 'Select'}}">
						<li *ngFor="let periodKey of dic.CONSTANTS.tpRule.notifyOptions | keyvalue: gs.returnZero"
							(click)="notifyOptionsPopup.notifyRecipientPeriods[periodKey.value] = !notifyOptionsPopup.notifyRecipientPeriods[periodKey.value]; notifyOptionsPopup.isNotifyRecipientPeriodsError = false; $event.stopPropagation();"
							id="{{'notifyRecipientPeriods_' + periodKey.key}}">
							<checkbox (click)="$event.preventDefault();"
									  [(model)]="notifyOptionsPopup.notifyRecipientPeriods[periodKey.value]">
								{{periodKey.value === dic.CONSTANTS.tpRule.notifyOptions.everyDay ? 'Custom notification times' : periodKey.value}}
							</checkbox>
						</li>
					</app-dropdown-c>
					<span style="position: absolute; bottom: -20px; right: 0;  font-size: 12px; color: red;"
						  *ngIf="notifyOptionsPopup.isNotifyRecipientPeriodsError">
						required field
					</span>
				</div>
			</div>

			<div class="list-group-item settings-list-item py-4" *ngIf="notifyOptionsPopup.notifyRecipientPeriods[dic.CONSTANTS.tpRule.notifyOptions.everyDay]">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Notification Hours</b>
					<span class="lh-base" style="font-size: 0.9em;">Select the hours of the day in which Inbound Shield notifications will be sent</span>
				</div>
				<div class="content-container pt-1">
					<app-dropdown-c class="limit-height" style="width: 200px;"
					                [error]="notifyOptionsPopup.isNotifyRecipientDailyHoursError"
					                text="{{gs.getDailyHoursText(notifyOptionsPopup.notifyRecipientDailyHours) || 'Select'}}">
						<li *ngFor="let twoDigitHour of gs.hoursArr"
						    (click)="toggleNotificationDailyHour(notifyOptionsPopup.notifyRecipientDailyHours, twoDigitHour); $event.stopPropagation();"
						    id="{{'notifyRecipientDailyHour_' + twoDigitHour}}">
							<checkbox (click)="$event.preventDefault();"
							          [model]="notifyOptionsPopup.notifyRecipientDailyHours.includes(twoDigitHour)">
								{{twoDigitHour + ':00'}}
							</checkbox>
						</li>
					</app-dropdown-c>
					<span style="position: absolute; bottom: -17px; right: 0;  font-size: 12px; color: red;"
					  *ngIf="notifyOptionsPopup.isNotifyRecipientDailyHoursError">
						required field
					</span>
				</div>
			</div>

			<div class="list-group-item settings-list-item py-4" *ngIf="notifyOptionsPopup.notifyRecipientPeriods[dic.CONSTANTS.tpRule.notifyOptions.everyDay]">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Notification Days</b>
					<span class="lh-base" style="font-size: 0.9em;">Select the days of the week in which Inbound Shield notifications will be sent</span>
				</div>
				<div class="content-container pt-1">
					<app-dropdown-c class="limit-height" style="width: 200px;"
					                [error]="notifyOptionsPopup.isNotifyRecipientDaysError"
					                [items]="notifyOptionsPopup.notifyRecipientDays"
					                [isMultipleSelection]="true"
					                [hideCounter]="true"
					                itemDisplayKey="day">
					</app-dropdown-c>
					<span style="position: absolute; bottom: -17px; right: 0;  font-size: 12px; color: red;"
					      *ngIf="notifyOptionsPopup.isNotifyRecipientDaysError">
                            required field
					</span>
				</div>
			</div>

			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Notification Email Title (Immediate Notification)</b>
					<span class="lh-base" style="font-size: 0.9em;" ngNonBindable>Customize the title of Inbound Shield immediate notifications which are sent to recipients. The following dynamic fields can also be used - {{RECIPIENT_EMAIL}}, {{EMAIL_SUBJECT}}, {{COMPANY_NAME}}.</span>
				</div>
				<div class="content-container overflow-auto pt-1">
					<input type="text" class="lowerPlaceholder" placeholder="{{quarantineEmailNotificationPlaceholder}}" style="margin: 0; width: 100%; box-sizing: inherit;"
					       [(ngModel)]="notifyOptionsPopup.notifyRecipientEmailTitle"/>
				</div>
			</div>

			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Notification Email Title (Scheduled Notification)</b>
					<span class="lh-base" style="font-size: 0.9em;" ngNonBindable>
Customize the title of Inbound Shield scheduled notifications which are sent to reviewers. The following dynamic fields can also be used - {{RECIPIENT_EMAIL}}, {{COMPANY_NAME}}, {{DETECTED_THREATS}}.
					</span>
				</div>
				<div class="content-container overflow-auto pt-1">
					<input type="text" class="lowerPlaceholder" placeholder="{{quarantineEmailDigestNotificationPlaceholder}}" style="margin: 0; width: 100%; box-sizing: inherit;"
					       [(ngModel)]="notifyOptionsPopup.notifyRecipientEmailDigestTitle"/>
				</div>
			</div>

			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Custom Message</b>
					<span class="lh-base" style="font-size: 0.9em;" ngNonBindable>
						Here you can add an optional message in HTML format that will be added to the notification sent to recipients. The following dynamic fields can also be added to the message: {{REC.NAME}} and {{REC.EMAIL}}.
					</span>
				</div>
				<div class="content-container overflow-auto pt-1">
					<textarea placeholder="Add HTML here"
					          style="height: 60px; width: 100%;"
					          [(ngModel)]="notifyOptionsPopup.notifyRecipientPeriodText">
					</textarea>
				</div>
			</div>


			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>User Notification Timing Configuration</b>
					<span class="lh-base" style="font-size: 0.9em;">Allow users to configure their own custom notification times via the portal</span>
				</div>
				<div class="content-container overflow-auto pt-1">
					<checkbox id="notify_recipient_allow_change_time"
							  [(model)]="notifyOptionsPopup.notifyRecipientAllowChangeTime">
					</checkbox>
				</div>
			</div>

			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Customize Reply-To Address</b>
					<span class="lh-base" style="font-size: 0.9em;">
Customize the Reply-To address of recipient quarantine reports. If disabled, the default Reply-To address will be that of your primary reviewer.
					</span>
				</div>
				<div class="content-container overflow-auto pt-1">
					<input type="text" class="lowerPlaceholder" placeholder="Email addresses" style="width: 300px;"
					       [(ngModel)]="notifyOptionsPopup.notifyReplyToEmail"/>
				</div>
			</div>

			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Include 'Review all emails' Button in Scheduled Notifications</b>
					<span class="lh-base" style="font-size: 0.9em;">Scheduled quarantine notifications will include a 'Review all emails' button that links to the user's "Email Activity" page in the web portal</span>
				</div>
				<div class="content-container overflow-auto pt-1">
					<checkbox id="notify_recipient_show_link_to_webapp"
							  [(model)]="notifyOptionsPopup.notifyRecipientShowLinkToWebapp">
					</checkbox>
				</div>
			</div>

			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Display Threat Detection Tag Information</b>
					<span class="lh-base" style="font-size: 0.9em;">Scheduled quarantine reports will also include the threat detection "tag" for each email that provides information about the specific threat types found in the email.</span>
				</div>
				<div class="content-container overflow-auto pt-1">
					<checkbox id="notify_recipient_show_tag_info"
					          [(model)]="notifyOptionsPopup.notifyRecipientShowTagInfo">
					</checkbox>
				</div>
			</div>
		</div>

		<div class="list-group list-group-flush settings-list-container" *ngIf="notifyOptionsPopup.activeTab === notifyOptionsPopup.tabs.releaseRequest">

			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Allow Recipient to Request Release</b>
					<span class="lh-base" style="font-size: 0.9em;">Recipient quarantine notifications will have a button to automatically send a request to the admin/reviewers to release the email</span>
				</div>
				<div class="content-container overflow-auto pt-1">
					<checkbox id="notifyRecipientAllowRequestRelease"
					          tooltipDirection="right"
					          [(model)]="notifyOptionsPopup.notifyRecipientAllowRequestRelease">
					</checkbox>
				</div>
			</div>

			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Require Specifying Release Request Reason</b>
					<span class="lh-base" style="font-size: 0.9em;">Recipients will be required to provide a reason for the release request</span>
				</div>
				<div class="content-container overflow-auto pt-1">
					<checkbox id="requireRecipientReleaseRequestReason"
					          tooltipDirection="right"
					          [isDisabled]="!notifyOptionsPopup.notifyRecipientAllowRequestRelease"
					          [(model)]="notifyOptionsPopup.requireRecipientReleaseRequestReason">
					</checkbox>
				</div>
			</div>

			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Release Request Recipients</b>
					<span class="lh-base" style="font-size: 0.9em;">Optional. You can add multiple email addresses separated by commas. If no address is provided here, the request will be sent to the primary reviewer. If a reviewer is assigned to specific mailboxes, release requests from those mailboxes will be sent to the assigned reviewer only</span>
				</div>
				<div class="content-container overflow-auto pt-1">
					<input type="text" class="lowerPlaceholder" placeholder="Email addresses separated by commas (optional)" style="margin: 0; width: 100%; box-sizing: inherit; flex: 1 0;"
					       [ngClass]="{'disable': !notifyOptionsPopup.notifyRecipientAllowRequestRelease}"
					       [disabled]="!notifyOptionsPopup.notifyRecipientAllowRequestRelease"
					       [(ngModel)]="notifyOptionsPopup.notifyRecipientAllowRequestReleaseEmail"/>
				</div>
			</div>

			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Release Request Email Title</b>
					<span class="lh-base" style="font-size: 0.9em;" ngNonBindable>
Dynamic fields like {{RECIPIENT_EMAIL}}, {{EMAIL_SUBJECT}} and {{COMPANY_NAME}} can be used to show information about the email. If this field is left empty, the default Trustifi subject will be used
					</span>
				</div>
				<div class="content-container overflow-auto pt-1">
					<input type="text" class="lowerPlaceholder" placeholder="{{releaseRequestSubjectPlaceholder}}" style="margin: 0; width: 100%; box-sizing: inherit;"
					       [ngClass]="{'disable': !notifyOptionsPopup.notifyRecipientAllowRequestRelease}"
					       [disabled]="!notifyOptionsPopup.notifyRecipientAllowRequestRelease"
					       [(ngModel)]="notifyOptionsPopup.notifyRecipientAllowRequestSubject"/>
				</div>
			</div>

			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
					<b>Use "From" Address of the Recipient</b>
					<span class="lh-base" style="font-size: 0.9em;">Release requests will be sent using the "From" address of the recipient who requested the email release</span>
				</div>
				<div class="content-container overflow-auto pt-1">
					<checkbox id="notify_recipient_allow_request_release_email_change_from"
					          [isDisabled]="!notifyOptionsPopup.notifyRecipientAllowRequestRelease"
					          [(model)]="notifyOptionsPopup.notifyRecipientAllowRequestReleaseFrom">
					</checkbox>
				</div>
			</div>
		</div>

		<div *ngIf="notifyOptionsPopup.activeTab === notifyOptionsPopup.tabs.recipient || notifyOptionsPopup.activeTab === notifyOptionsPopup.tabs.reviewer"
			 class="flex-row align-items-start gap-2 p-2 mt-2" style="background: #fff3e0; border-radius: 4px;">
			<i class="far fa-info-circle mt-1" style="color: #e65100;"></i>
			<span>
Changes take effect immediately. However, any notifications already batched under the previous schedule will be delivered as originally scheduled. The new frequency will be applied starting with the next notification cycle.			</span>
		</div>
	</div>
</ng-template>
